module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/assessment-admin/assessment-admin.component.html
// module id = ./src/app/admin/assessment-admin/assessment-admin.component.html
// module chunks = main